import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ScaleYourBrand from "./sections/ScaleYourBrand";
import WhatWeDo from "./sections/WhatWeDo";
import WhyChooseUs from "./sections/WhyChooseUs";
import HowWeWork from "./sections/HowWeWork";
import ContactUs from "./sections/ContactUs";
import Aboutpineplayerz from "./sections/Aboutpineplayerz";
import Ethos from "./sections/Ethos";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ScaleYourBrand />
      <WhatWeDo />
      <WhyChooseUs />
      <HowWeWork />
      <Aboutpineplayerz />
      <Ethos />
      <ContactUs />
      <Footer />
    </div>;
}